import React, { useEffect, useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AuthContext from "../../context/userAuth.context";
import Button from "@mui/material/Button";
import axios from "axios";
import Swal from "sweetalert";

import CharacterContext from "../../context/CharacterContext";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";

import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Padding } from "@mui/icons-material";
const RenameModal = (props) => {
  const [newProjectName, setnewProjectName] = useState("");
  useEffect(() => {
    setnewProjectName("");
  }, [props.showRenameModal]);
  const SaveName = () => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    fetch(
      props.authenticationData.ApiBaseURL +
        `/api/Project/RenameProject?id=${props.value.id}&newName=${newProjectName}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        if (res) {
          let array = Array.from(props.AllProject);
          for (let i = 0; i < array.length; i++) {
            if (array[i].id == props.value.id) {
              array[i].projectName = newProjectName;
            }
          }
          props.setAllProject(array);
          props.setshowRenameModal(false);
        }
      })
      .catch((error) => {});
  };

  return (
    <>
      <Dialog
        open={props.showRenameModal}
        onClose={() => props.setshowRenameModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title mr-4"
          style={{ marginRight: "100px" }}
        >
          Rename your project
          <IconButton
            onClick={() => props.setshowRenameModal(false)}
            style={{ position: "absolute", right: "10px", top: "10px" }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TextField
            label="New project name"
            onChange={(e) => setnewProjectName(e.target.value)}
            variant="outlined"
            color="secondary"
            sx={{ mb: 3, mt: 3 }}
            fullWidth
            value={newProjectName}
          />

          <DialogActions>
            <Button onClick={() => props.setshowRenameModal(false)}>
              Cancel
            </Button>
            <Button variant="contained" disableElevation onClick={SaveName}>
              Save Changes
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RenameModal;
